import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '../../Form/Input';
import TextArea from '../../Form/TextArea';

interface CandidateFormData {
  education: string;
  previousCompany: string;
  coverLetter: string;
  [key: string]: any;
}

interface CandidateProfessionalBackgroundProps {
  register: UseFormRegister<CandidateFormData>;
  errors: FieldErrors<CandidateFormData>;
  certificates: string;
  languages: string;
  onCertificatesChange: (value: string) => void;
  onLanguagesChange: (value: string) => void;
}

const CandidateProfessionalBackground: React.FC<CandidateProfessionalBackgroundProps> = ({
  register,
  errors,
  certificates,
  languages,
  onCertificatesChange,
  onLanguagesChange,
}) => {
  return (
    <div className="border-b border-gray-200 pb-6">
      <h4 className="text-md font-medium text-gray-900 mb-4">Professional Background</h4>
      <div className="space-y-6">
        <Input
          label="Education"
          {...register('education')}
          error={errors.education?.message}
          placeholder="e.g., Maritime Academy, Alexandria"
        />

        <Input
          label="Previous Company"
          {...register('previousCompany')}
          error={errors.previousCompany?.message}
          placeholder="e.g., Mediterranean Shipping"
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Certificates
          </label>
          <textarea
            value={certificates}
            onChange={(e) => onCertificatesChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            rows={2}
            placeholder="Enter certificates separated by commas (e.g., Master Mariner License, STCW II/2)"
          />
          <p className="mt-1 text-xs text-gray-500">
            Separate multiple certificates with commas
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Languages
          </label>
          <textarea
            value={languages}
            onChange={(e) => onLanguagesChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            rows={2}
            placeholder="Enter languages separated by commas (e.g., Arabic, English, French)"
          />
          <p className="mt-1 text-xs text-gray-500">
            Separate multiple languages with commas
          </p>
        </div>

        <TextArea
          label="Cover Letter"
          {...register('coverLetter')}
          error={errors.coverLetter?.message}
          placeholder="Candidate's cover letter or application message..."
          rows={4}
        />
      </div>
    </div>
  );
};

export default CandidateProfessionalBackground;
